import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./index.scss";
function Electronic() {
  const { t } = useTranslation();
  const language = localStorage.getItem("i18nextLng");
  const dataValueContent = t("residency.space_part3", {
    returnObjects: true,
  });
  return (
    <div className="dataValue_">
      <div className="edition_solution edition_solution_top">
        <div className="edition_solution_title">
          <div>{dataValueContent.title}</div>
        </div>
      </div>
      <div className="dataValue_con">
        {dataValueContent.list.map((item0, index0) => {
          return (
            <div className="dataValue_li" key={index0}>
              <div className="dataValue_li_img">
                <img src={item0.iconUrl} alt="" />
              </div>
              <div className="dataValue_li_des">
                <div className="dataValue_li_til">{item0.itemTitle}</div>
                <div className="dataValue_li_con">{item0.itemContent}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Electronic;
